import { useCallback } from 'react';
import { useFlagsService } from '@atlassian/jira-flags';
import { toFlagId } from '@atlassian/jira-flags/src/services/types';
import messages from './messages.tsx';

export const useLayoutChangeErrorFlag = () => {
	const { showFlag } = useFlagsService();

	return useCallback<() => void>(() => {
		showFlag({
			key: toFlagId('layoutChangeError'),
			type: 'error',
			title: messages.changeLayoutErrorFlagTitle,
			description: messages.changeLayoutErrorFlagDescription,
			messageId: 'dashboard-edit.utils.change-layout-error.show-flag.error',
			messageType: 'transactional',

			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			actions: [{ content: messages.errorFlagAction, onClick: () => window.location.reload() }],
		});
	}, [showFlag]);
};
